<template>
  <nna-container>
    <div class="align-middle">    
      <h1 class="md-title">Inserisci la nuova password</h1>
      <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>-->
      <form novalidate class="md-layout" @submit.prevent="onSubmitForm">
        <md-field :class="getValidationClass('code')">
          <label for="code">Codice ricevuto via email o sms</label>
          <md-input name="code" id="code" autocomplete="name" v-model="form.code" :disabled="sending" />
          <span class="md-error" v-if="!$v.form.code.required">Inserisci il codice</span>
        </md-field>
        <md-field :class="getValidationClass('password')">
          <label for="first-name">Password</label>
          <md-input name="password" id="password" autocomplete="password" v-model="form.password" :disabled="sending" type="password"/>
          <span class="md-error" v-if="!$v.form.password.required">Inserisci la tua password</span>
          <span class="md-error" v-else-if="!$v.form.password.minlength">Password non valido</span>
        </md-field>
        <md-field :class="getValidationClass('mpassword')">
          <label for="mpassword">Conferma Password</label>
          <md-input name="mpassword" id="mpassword" autocomplete="mpassword" v-model="form.mpassword" :disabled="sending" type="password"/>
          <span class="md-error" v-if="!$v.form.mpassword.required">Inserisci la tua password</span>
          <span class="md-error" v-else-if="!$v.form.mpassword.minlength">Password non valido</span>
          <span class="md-error" v-else-if="!$v.form.mpassword.sameAsPassword">La password non coicidono</span>
        </md-field>            
        <md-button type="submit" class="md-raised md-primary" md-align="center">Cambia password</md-button>
      </form>
    </div>
  </nna-container>  
</template>

<script>
import CMM from '@nonameapp-core'
import { mapActions } from 'vuex'
export default {
  name: 'RecoverPasswordSendCode',
  mixins: [ 
    CMM._mixins.form("recoverPasswordSendCode")
  ],
  data() {
    return {
      form: {
        code: null,
        password: null,
        mpassword: null
      }
    }
  },
  methods: {
    ...mapActions({
      resetPasswordSendCode: "auth/resetPasswordSendCode",
    }),
    onSubmitForm () {
      if(this.validateForm()) this.recover()
    },   
    async recover() {
      this.sending = true
      try { 
        //this.form.username = this.showPrefix ? `${this.form.prefix}${this.form.username}` : this.form.username
        this.form.username = this.$route.query.username
        const { data } = await this.resetPasswordSendCode(this.form)
        if(data.hcode === "ok") {
          this.sending = false
          this.clearForm()
          this.$router.push({ name: "signup.done" })
        } else {
          this.sending = false
          this.$toasted.show(data.msg, { type: 'error' })
        }        
     } catch (errors) {
       console.error("Error:", errors)
       this.sending = false
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }      
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/auth/login/pages/RecoverPasswordSendCode.vue